import React, {Component} from 'react'
import {connect} from 'react-redux'
import {NavLink} from 'react-router-dom'
import * as Yup from 'yup'
import {Form, Formik} from 'formik'
import * as FormConst from '../../../../constants/FormConst'
import RouteConst from '../../../../constants/RouteConst'
import SessionConst from '../../../../constants/SessionConst'
import SideNavEntryMapping from '../../../../constants/SideNavEntryMapping'
import {asyncMethod} from '../../../../redux/actions'
import * as actionTypes from '../../../../redux/actionTypes'
import {getSessionItem} from '../../../../utilities/SessionHelper'
import withFormLayout from '../WithFormLayout'
import './RoomTypeBuckets.scss'
import RoomTypeBucketsService from "../../../../services/RoomTypeBucketsService";
import RoomTypesService from "../../../../services/RoomTypesService";
import {Col, Row} from "react-bootstrap";
import Button from "../../../atoms/Button/Button";
import {FaEdit, FaTrashAlt} from "react-icons/fa";
import TextInput from "../../../atoms/form/TextInput/TextInput";
import Card from "../../../molecules/Card/Card";
import SelectList from "../../../atoms/form/SelectList/SelectList";
import FormModal from "../../../organisms/FormModal/FormModal";

class RoomTypeBucket extends Component {

    constructor(props) {
        super(props)
        const hotelCode = getSessionItem(SessionConst.HOTEL_CODE)
        const hotelInfo = getSessionItem(SessionConst.HOTEL_INFO)
        const brandName = hotelInfo.brandName
        let roomTypeBucket = this.props.history.location?.state?.roomTypeBucket

        if (!hotelCode || !hotelInfo) {
            // Go home
            this.props.history.replace(RouteConst.ROUTE_HOME_PAGE)
        }

        this.state = {
            hotelCode: hotelCode,
            hotelInfo: hotelInfo,
            roomTypeBucket: roomTypeBucket,
            roomTypes: this.props.history.location?.state?.roomTypes,
            initialValues: this.initialValues,
            originalRoomTypesOptions: [],
            roomTypeBuckets: [],
            continueFlow: this.props.history.location?.state?.continueFlow,
            editIndex: this.props.history.location?.state?.editIndex !== undefined ? this.props.history.location?.state?.editIndex : -1,
            showNewFields: this.props.history.location?.state?.showNewFields,
            errorMessage: undefined,
            isLoading: true,
            loadingMessage: FormConst.MODAL_READ_ACTION_TEXT,
            showResetModal: false,
            showDeleteModal: false,
            showErrorModal: false
        }
    }

    // Default initial values for form fields
    initialValues = {
        name: '',
        level: 1,
        selectedRoomTypeOptions: [],
        filteredRoomTypesOptions: [],
        roomTypes: this.props.history.location?.state?.roomTypes,
        type: FormConst.ROOM_TYPE_BUCKET,
        isEdit: false
    }

    // Validation schema for form fields
    validationSchema = Yup.object().shape({
        name: Yup.string().required(FormConst.VALIDATION_ERROR_REQUIRED)
        .max(FormConst.ROOM_TYPE_BUCKET_NAME_MAXIMUM_LENGTH,
            `Maximum ${FormConst.ROOM_TYPE_BUCKET_NAME_MAXIMUM_LENGTH} characters`)
        .matches(FormConst.TEXT_PATTERN_ALPHA_NUMERIC, FormConst.VALIDATION_ERROR_ALPHA_NUMERIC_CHARACTERS),
        level: Yup.number().typeError(FormConst.VALIDATION_ERROR_NUMBERS_ONLY).required(FormConst.VALIDATION_ERROR_REQUIRED)
            .min(1, 'Min value is 1')
            .max(6, 'Max value is 6'),
    })

    /**
     * Lifecycle method that runs after the component mounts. Gets data from the service and sets
     * initial values for the form.
     */
    async componentDidMount() {
        await this.refreshData()
    }

    async refreshData () {
        let existingRoomTypeBuckets = []
        let roomTypes = []
        let assignedRoomTypes = []
        let originalRoomTypesOptions = []
        let filteredRoomTypesOptions = []
        let selectedRoomTypeOptions = []
        let roomTypesBucket = this.state.roomTypeBucket

        await RoomTypeBucketsService.getRoomTypesBuckets({ hotelCode: this.state.hotelCode }).then(async (response) => {
            existingRoomTypeBuckets = response.roomTypeBuckets
            existingRoomTypeBuckets.map(bucket => {
                bucket.roomTypes.map(roomType => { assignedRoomTypes.push(roomType)} )
            })
        }).catch(error => {
            this.setState({
                              isLoading: false,
                              showErrorModal: true,
                              errorMessage: 'There was an error while retrieving Hotel Room Type Buckets data'
                          })
        })

        // retrieve hotel room type buckets
        await RoomTypesService.getRoomTypes({hotelCode: this.state.hotelCode})
            .then(async (response) => {
                roomTypes = response.roomTypes
                roomTypes.filter( roomType => !assignedRoomTypes.includes(roomType.hotelRoomTypeCode))
                    .map(roomType => {
                        filteredRoomTypesOptions.push(
                            {
                                value: roomType.hotelRoomTypeCode,
                                label:roomType.hotelRoomTypeCode + ' - ' + roomType.description})
                    })
                roomTypes.map(roomType => {
                    originalRoomTypesOptions.push(
                        {
                            value: roomType.hotelRoomTypeCode,
                            label:roomType.hotelRoomTypeCode + ' - ' + roomType.description})
                })
            }).catch(error => {
                this.setState({
                                  isLoading: false,
                                  showErrorModal: true,
                                  errorMessage: 'There was an error while retrieving Hotel Room Type Buckets data'
                              })
            })

        let initialValues = {
            name: '',
            level: 1,
            filteredRoomTypesOptions: filteredRoomTypesOptions,
            selectedRoomTypeOptions: selectedRoomTypeOptions,
            roomTypes: this.state.roomTypes,
            type: FormConst.ROOM_TYPE_BUCKET,
            isEdit: false
        }

        if (this.props.history.location.state && this.props.history.location.state.isEdit
            && this.props.history.location.state.editIndex !== undefined) {
            const entryToEdit = existingRoomTypeBuckets[this.props.history.location.state.editIndex]
            if(entryToEdit !== undefined) {
                initialValues.name = entryToEdit.name
                initialValues.level = entryToEdit.level
                initialValues.roomTypes = entryToEdit.roomTypes
                initialValues.selectedRoomTypeOptions = entryToEdit.roomTypes
                initialValues.isEdit = true
            }
        }

        this.setState({
                          count: this.props.count,
                          isLoading: false,
                          existingRoomTypeBuckets: existingRoomTypeBuckets,
                          originalRoomTypesOptions: originalRoomTypesOptions,
                          roomTypes: this.state.roomTypes,
                          initialValues: initialValues,
                          showNewFields: this.props.history.location?.state?.showNewFields,
                      })

    }

    /**
     * Updates the Hotel Contacts with the form changes and calls the service with updated values.
     * 
     * @param {Object} formData The form data
     * @param {Function} resetFormData The reset method provided by formik
     * @returns {undefined}
     */
    handleSubmit = (formData, resetFormData) => {
        let continueProcessing = true
        const newRoomTypeBucket = { ...formData }
        delete newRoomTypeBucket.filteredRoomTypesOptions
        delete newRoomTypeBucket.selectedRoomTypeOptions
        delete newRoomTypeBucket.type
        delete newRoomTypeBucket.isEdit

        newRoomTypeBucket.roomTypes = this.state.initialValues.selectedRoomTypeOptions

        if(!this.state.initialValues.isEdit) {
            let index = this.state.existingRoomTypeBuckets.findIndex(bucket => bucket.name === newRoomTypeBucket.name)
            if(index !== -1) {
                continueProcessing = false
                this.setState({
                    errorMessage: "There is another bucket with the same name",
                    showErrorModal: true,
                    isLoading: false
                })

            }

        }

        if(continueProcessing) {
            let roomTypeBuckets = this.state.existingRoomTypeBuckets.filter( bucket => bucket.name !== newRoomTypeBucket.name)
            roomTypeBuckets.push(newRoomTypeBucket)

            const data = { hotelCode: this.state.hotelCode, roomTypeBuckets: roomTypeBuckets}

            if(this.state.initialValues.isEdit){
                this.props.onPutRoomTypeBuckets(data)
            } else {
                this.props.onPostRoomTypeBuckets(data)
            }


            this.setState({
                              count: this.props.count + 1,
                              roomTypes: this.state.roomTypes,
                              initialValues: this.initialValues,
                              errorMessage: undefined,
                              isLoading: true,
                              loadingMessage: FormConst.MODAL_UPDATE_ACTION_TEXT,
                              resetFormData: resetFormData
                          })
        }



    }

    /**
     * Displays reset modal
     */
    handleResetForm = () => {
        this.refreshData()
    }

    /**
    * Resets form data and hides the reset modal
    * @param {Function} formikResetFormMethod the formik reset method
    */
    resetFormData = (formikResetFormMethod) => {
        formikResetFormMethod()
        this.setState({
            showResetModal: false,
            roomTypes: this.state.roomTypes,
            initialValues: this.state.initialValues,
            editIndex: -1,
            errorMessage: undefined
        })
    }

    /**
     * Lifecycle method to handle this component's update. Only handles updates which are a result
     * of HTTP async actions.
     * 
     * @param {Object} prevProps properties before the current update
     */
    componentDidUpdate(prevProps) {
        if (prevProps.count !== this.state.count) {
            this.props.history.push(
                {
                    pathname: RouteConst.ROUTE_ROOM_TYPE_BUCKETS_PAGE,
                })
        }
    }

    /**
     * This method handles the delete operation
     * @param name the name of the bucket to be deleted
     */
    async deleteBucket(e) {
        e.preventDefault()
        const data = {
            hotelCode: this.state.hotelCode,
            name: this.state.bucketName
        }
        await RoomTypeBucketsService.deleteRoomTypesBuckets(data)
        this.refreshData()
        this.setState( {showDeleteModal:false} )
    }

    /**
     * Displays the room type bucket details field and fills them up with the values using the room
     * type bucket to be edited.
     * 
     * @param {number} index the index of the entry to be edited
     */
    onEdit = (index, existingRoomTypeBuckets) => {
        const entryToEdit = existingRoomTypeBuckets[index]
        let initialValues = {
            ...this.state.initialValues,
            name: entryToEdit.name,
            level: entryToEdit.level,
            roomTypes: entryToEdit.roomTypes,
            selectedRoomTypeOptions: entryToEdit.roomTypes,
            isEdit: true
        }

        this.setState({
            initialValues: initialValues,
        })
    }

    /**
     * Remove roomType from the list of selection in form
     * 
     * @param {roomTypeName} the name or code of the roomType of the entry to be deleted
     */
    onRemoveRoomType = (roomTypeName) => {
        let selectedRoomTypeOptions = []
        this.state.initialValues.selectedRoomTypeOptions.filter(option => option !== roomTypeName)
            .map(option => selectedRoomTypeOptions.push(option))
        this.state.originalRoomTypesOptions.filter(option => option.value === roomTypeName)
            .map(option => this.state.initialValues.filteredRoomTypesOptions.push(option))
        let remainingOptions = this.state.initialValues.filteredRoomTypesOptions

        let initialValues = {
            ...this.state.initialValues,
            filteredRoomTypesOptions: remainingOptions,
            selectedRoomTypeOptions: selectedRoomTypeOptions
        }

        this.setState({ initialValues: initialValues })
    }

    /**
     * Updates the list of available roomTypes to select and the table of
     * room types to add for a bucket
     * @param selectedRoomTypes the room types selected
     * @param name is the name of the bucket
     * @param level is the level from 1 to 6 of the bucket
     */
    onSelectRoomType = (selectedRoomTypes, name, level) => {
        selectedRoomTypes.forEach( roomType => {
            this.state.initialValues.selectedRoomTypeOptions.push(roomType)
        });

        let selectedRoomTypeOptions = this.state.initialValues.selectedRoomTypeOptions
        let remainingOptions = this.state.initialValues.filteredRoomTypesOptions.filter(option => !selectedRoomTypeOptions.includes(option.value))

        let initialValues = {
            ...this.state.initialValues,
            filteredRoomTypesOptions: remainingOptions,
            name: name,
            level: level
        }

        this.setState({ initialValues: initialValues })
    }


    render() {
        let existingRoomTypeBucketsTable = <table id='room-type-bucket-page-table' className='table table-striped table-responsive room-type-bucket-table'>
                <thead>
                <tr>
                    <th className='w-50'>Name</th>
                    <th className='w-25'>Level</th>
                    <th className='w-25'>Room Types</th>
                    <th>Edit</th>
                    <th>Delete</th>
                </tr>
                </thead>
                <tbody>
                {
                    this.state.existingRoomTypeBuckets?.length > 0 ?
                    (
                        this.state.existingRoomTypeBuckets.map((bucket, index) => {
                            return <tr key={index}>
                                <td>{bucket.name}</td>
                                <td>{bucket.level}</td>
                                <td>{bucket.roomTypes.join(', ')}</td>
                                <td><Button name={<FaEdit />} role='link' className='icon-link'
                                            onClick={() => this.onEdit(index, this.state.existingRoomTypeBuckets)}
                                            overridedisabledflag='true' /></td>
                                <td><Button name={<FaTrashAlt />} role='link' className={this.state.showNewFields ? 'icon-link-disabled' : 'icon-link'}
                                            onClick={() => this.setState({
                                                showDeleteModal: true,
                                                bucketName: bucket.name
                                            })} /></td>
                            </tr>
                        })
                    )
                                                            : (
                        <tr>
                            <td colSpan={74}>There are no entries for roomTypes</td>
                        </tr>
                    )
                }
                </tbody>
            </table>

        let existingRoomTypeBucketsCard = <Card
            id='room-type-bucket-table'
            header={FormConst.LABEL_ROOM_TYPE_BUCKETS}
            title=''
            text={existingRoomTypeBucketsTable}
            actions={[]}
            className={'room-type-bucket-form-element'}
            isFill />

        let selectedRoomTypesTable = <div className={'room-type-bucket-page-table'}>
            <table
                className='table table-striped'>
                <thead>
                <tr>
                    <th>Name</th>
                    <th>Delete</th>
                </tr>
                </thead>
                <tbody>
                {
                    this.state.initialValues.selectedRoomTypeOptions?.length > 0 ?
                    (
                        this.state.initialValues.selectedRoomTypeOptions.map((roomType, index) => {
                            return <tr key={index}>
                                <td>{roomType}</td>
                                <td><Button name={<FaTrashAlt />} role='link' className={this.state.showNewFields ? 'icon-link-disabled' : 'icon-link'}
                                            onClick={() => this.onRemoveRoomType(roomType)}/></td>
                            </tr>
                        })
                    )
                                                     : (
                        <tr>
                            <td colSpan={7}>No room types selected for this bucket</td>
                        </tr>
                    )
                }
                </tbody>
            </table>
        </div>


        return (
            <div className='room-type-bucket-page'>
                <Formik
                    initialValues={this.state.initialValues}
                    validationSchema={this.validationSchema}
                    enableReinitialize={true}
                    onSubmit={(data, {setSubmitting, resetForm}) => {
                        setSubmitting(true)
                        this.handleSubmit(data, () => resetForm({values: this.state.initialValues}))
                        setSubmitting(false)
                    }}>
                    {({values, isSubmitting, resetForm}) => (
                        <Form className=''>

                            <nav aria-label="breadcrumb">
                                <ol className="breadcrumb">
                                    <li className="breadcrumb-item"><NavLink
                                        to={RouteConst.ROUTE_HOME_PAGE}>Home</NavLink></li>
                                    <li className="breadcrumb-item"><NavLink
                                        to={RouteConst.ROUTE_ROOM_TYPES_PAGE}>Room Types</NavLink>
                                    </li>
                                    <li className="breadcrumb-item"><NavLink
                                        to={RouteConst.ROUTE_ROOM_TYPE_BUCKETS_PAGE}>Room Type
                                        Buckets</NavLink></li>
                                    <li className="breadcrumb-item active" aria-current="page">Room
                                        Type Bucket
                                    </li>
                                </ol>
                            </nav>

                            {
                                !this.state.isLoading
                                && (
                                    <div className={'container'}>

                                        <Row className='justify-content-start card-room-type'>
                                            <Col xl={12} className='d-flex box'>
                                                {existingRoomTypeBucketsCard}
                                            </Col>
                                        </Row>

                                        <Card
                                            id='room-type-bucket-form-card'
                                            header={FormConst.LABEL_ROOM_TYPE_BUCKET_FORM}
                                            title={''}
                                            text={
                                                <Row className='align-items-center'>
                                                    <Col xs={12} sm={6} xl={4} className='align-self-start'>
                                                        <SelectList
                                                            name='selectedRoomTypeOptions'
                                                            id='selectedRoomTypeOptions'
                                                            label='Available Room Types'
                                                            labelClass='w-100'
                                                            selectClass='w-100'
                                                            mainClassName='d-block'
                                                            options={this.state.initialValues.filteredRoomTypesOptions}
                                                            overridedisabledflag={true}
                                                            title=''/>
                                                    </Col>
                                                    <Col xs={4} sm={4} xl={1} className='d-flex box'>
                                                        <Button
                                                            name='Add >>'
                                                            id='add-button'
                                                            className='add-button'
                                                            onClick={() => { this.onSelectRoomType(values.selectedRoomTypeOptions, values.name, values.level) }}/>
                                                    </Col>
                                                    <Col xs={12} sm={12} xl={4}>
                                                        <div className='room-type-bucket-page-collapse-fields'>
                                                            <div className='room-type-bucket-page-form-fields'>
                                                                <TextInput id='name' name='name' type='text' label='Name' isrequired='true' disabled={this.state.initialValues.isEdit}/>
                                                                <TextInput id='level' name='level' type='number' label='Level' isrequired='true' />
                                                            </div>

                                                            {selectedRoomTypesTable}
                                                        </div>

                                                        <div className='room-type-bucket-action-buttons'>
                                                            <Button
                                                                id='save-button'
                                                                type="submit" name={FormConst.SAVE_LINK_TEXT} />
                                                            <Button
                                                                id='discard-button'
                                                                name={FormConst.DISCARD_LINK_TEXT}
                                                                onClick={() => this.handleResetForm()}
                                                                overridedisabledflag='true' />
                                                        </div>
                                                        {/* Error message. Used explicitly for displaying errors. */}
                                                        {
                                                            this.state.errorMessage
                                                            && <p className='room-type-bucket-page-error-message'>{this.state.errorMessage}</p>
                                                        }

                                                    </Col>
                                                </Row>

                                            }
                                            actions={[]}
                                            className={''}
                                            isFill />

                                        <FormModal
                                            id='room-type-page-error-modal'
                                            hotelInfo={this.state.hotelInfo}
                                            title='Delete Room Type Bucket'
                                            body={<h5>{FormConst.MODAL_DELETE_ACTION_TEXT}</h5>}
                                            proceed={(e) => this.deleteBucket(e)}
                                            cancel={() => { this.setState({ showDeleteModal: false}) }}
                                            show={this.state.showDeleteModal} />
                                        <FormModal
                                            id='room-type-page-error-modal'
                                            hotelInfo={this.state.hotelInfo}
                                            title={FormConst.MODAL_UPDATE_ACTION_ERROR_TITLE}
                                            body={<h5>{this.state.errorMessage}</h5>}
                                            isError
                                            cancel={() => { this.setState({ showErrorModal: false }) }}
                                            show={this.state.showErrorModal} />
                                    </div>
                                )
                            }
                        </Form>
                    )}
                </Formik>
            </div>
        )
    }
}

// Sample redux dispatch
const mapStateToProps = state => {
    return {
        roomTypeBucketsResponse: state.reducer.response,
        errorMessage: state.reducer.errorMessage,
        errorDescription: state.reducer.errorDescription,
        count: state.reducer.count
    }
}

const mapDispatchToProps = dispatch => {
    return {
        onPutRoomTypeBuckets: (data) => dispatch(asyncMethod(FormConst.FORM_ROOM_TYPE_BUCKETS, actionTypes.ASYNC_ACTIONS.PUT, data)),
        onPostRoomTypeBuckets: (data) => dispatch(asyncMethod(FormConst.FORM_ROOM_TYPE_BUCKETS, actionTypes.ASYNC_ACTIONS.POST, data))
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(withFormLayout(RoomTypeBucket, SideNavEntryMapping.ROOM_TYPES))